<template>
  <b-row>
    <b-col>
      <span>{{ $t('general.posArticleNumberList') }}</span>
      <textarea v-model="draft" @blur="syncToArray"
        :placeholder="$t('general.posArticleNumberListPlaceholder')"></textarea>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "PosArticleListEdit",
  model: {
    prop: 'posArticleNumberList',
    event: 'update:posArticleNumberList'
  },
  props: {
    posArticleNumberList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      draft: this.toNewLines(this.posArticleNumberList)
    };
  },
  watch: {
    posArticleNumberList(newVal) {
      this.draft = this.toNewLines(newVal);
    }
  },
  methods: {
    /**
     * Convert array to newline separated string for editing
     */
    toNewLines(list) {
      if (Array.isArray(list)) {
        return list.join('\n');
      }
      return list;
    },
    /**
     * Convert newline separated draft to a clean JSON array and emit it
     */
    syncToArray() {
      const lines = String(this.draft).split('\n').map(line => line.trim()).filter(line => line.length > 0);
      this.$emit('update:posArticleNumberList', lines);
    }
  }
}
</script>
